import { settingsRequest } from '../api/adminSettings';

const bridgeUrl = 'https://cdn.shopify.com/shopifycloud/app-bridge.js';
let bridgeLoad;

export function loadShopifyBridge() {
  if (window.shopify && customElements.get('s-app-nav')) return Promise.resolve();
  if (!bridgeLoad) {
    bridgeLoad = settingsRequest('g-admin-context').then(({ api_key }) => {
      if (!api_key) throw new Error('Shopify app client ID is unavailable.');
      let meta = document.querySelector('meta[name="shopify-api-key"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'shopify-api-key';
        document.head.prepend(meta);
      }
      meta.content = api_key;

      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        const timeout = setTimeout(() => fail(), 15000);
        const fail = () => {
          clearTimeout(timeout);
          script.onload = script.onerror = null;
          script.remove();
          reject(new Error('Shopify navigation could not initialize. Use the navigation links below or retry.'));
        };
        script.src = bridgeUrl;
        // Dynamically created scripts default to async; App Bridge expects to be first and non-async.
        script.async = false;
        script.onload = () => {
          customElements.whenDefined('s-app-nav').then(() => {
            if (!window.shopify) { fail(); return; }
            clearTimeout(timeout);
            script.onload = script.onerror = null;
            resolve();
          });
        };
        script.onerror = fail;
        const firstScript = document.head.querySelector('script');
        document.head.insertBefore(script, firstScript);
      });
    }).catch(error => { bridgeLoad = null; throw error; });
  }
  return bridgeLoad;
}
